<template>
  <div data-component-group="line-item-dialog-kb" data-component="edit">
    <dialog-base
      content-class="edit-line-item-dialog-kb"
      is-fullscreen
      :is-on="isOn"
      :on-close="onCancel"
    >
      <template v-slot:title>
        <div class="dialog-header">
          <v-icon class="item-close" @click="onCancel"> close </v-icon>
          <div class="item-title">
            <h1>{{ $t('ad') }}</h1>
          </div>
        </div>
      </template>

      <template v-slot:content>
        <div class="dialog-content">
          <panels-line-items-hero-k-b
            :order="order"
            :line-item="lineItem"
            :is-loading="isLoading"
            :is-updating="isUpdating"
            :on-change-status="onChangeStatus"
          />
          <forms-line-add-new-k-b
            :order="order"
            :line-item="lineItem"
            :promoted-deal="{}"
            :is-on="isOn"
            :is-loading-items="isLoading || isLoadingDetails"
            :on-cancel="onCancel"
            :on-submit="onConfirm"
            is-edit
          />
        </div>
      </template>
    </dialog-base>
  </div>
</template>

<script>
  export default {
    props: {
      order: {
        type: Object,
        required: true,
      },
      lineItem: {
        type: Object,
        required: true,
      },
      isOn: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      isLoadingDetails: {
        type: Boolean,
        default: false,
      },
      isUpdating: {
        type: Boolean,
        required: true,
      },
      onCancel: {
        type: Function,
        required: true,
      },
      onConfirm: {
        type: Function,
        required: true,
      },
      onChangeStatus: {
        type: Function,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
.edit-line-item-dialog-kb.modal > .modal__backdrop > .modal__content {
  width: 100%;
  height: 100%;
  background-color: #eceff1;

  .v-theme--dark & {
    background-color: rgb(var(--v-theme-background));
  }

  .modal__header .dialog-header {
    padding: 0;
    width: 100%;
    display: flex;

    .item-title {
      padding: 28px 12px;
      color: white;

      h1 {
        font-size: 24px;
      }
    }

    .item-close {
      margin: 30px;
      color: white;
      display: block;
      height: 24px;
      width: 24px;
      min-height: 24px;
      min-width: 24px;
    }
  }

  > .modal__body {
    display: flex;
    justify-content: center;

    .dialog-content {
      margin: 16px 0 30px;
      padding: 0;
      width: 650px;
      height: calc(100vh + 215px);
    }
  }
}
</style>
